{ "compressionlevel":-1,
 "height":14,
 "infinite":false,
 "layers":[
        {
         "id":7,
         "image":"image.png",
         "name":"image",
         "opacity":1,
         "type":"imagelayer",
         "visible":true,
         "x":0,
         "y":0
        }, 
        {
         "data":[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
         "height":14,
         "id":1,
         "name":"tiles",
         "opacity":1,
         "type":"tilelayer",
         "visible":true,
         "width":19,
         "x":0,
         "y":0
        }, 
        {
         "draworder":"topdown",
         "id":3,
         "name":"data:encounters",
         "objects":[
                {
                 "height":0,
                 "id":3,
                 "name":"",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        }, 
                        {
                         "x":210,
                         "y":0
                        }, 
                        {
                         "x":210,
                         "y":70
                        }, 
                        {
                         "x":280,
                         "y":70
                        }, 
                        {
                         "x":280,
                         "y":210
                        }, 
                        {
                         "x":0,
                         "y":210
                        }],
                 "properties":[
                        {
                         "name":"slug",
                         "type":"string",
                         "value":"2"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":0,
                 "x":630,
                 "y":560
                }, 
                {
                 "height":0,
                 "id":4,
                 "name":"",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        }, 
                        {
                         "x":0,
                         "y":-280
                        }, 
                        {
                         "x":-140,
                         "y":-280
                        }, 
                        {
                         "x":-140,
                         "y":-210
                        }, 
                        {
                         "x":-210,
                         "y":-210
                        }, 
                        {
                         "x":-210,
                         "y":0
                        }],
                 "properties":[
                        {
                         "name":"slug",
                         "type":"string",
                         "value":"3"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":0,
                 "x":560,
                 "y":700
                }, 
                {
                 "height":0,
                 "id":40,
                 "name":"",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        }, 
                        {
                         "x":140,
                         "y":0
                        }, 
                        {
                         "x":140,
                         "y":70
                        }, 
                        {
                         "x":280,
                         "y":70
                        }, 
                        {
                         "x":280,
                         "y":140
                        }, 
                        {
                         "x":350,
                         "y":140
                        }, 
                        {
                         "x":350,
                         "y":210
                        }, 
                        {
                         "x":280,
                         "y":210
                        }, 
                        {
                         "x":280,
                         "y":280
                        }, 
                        {
                         "x":0,
                         "y":280
                        }],
                 "properties":[
                        {
                         "name":"slug",
                         "type":"string",
                         "value":"1"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":0,
                 "x":630,
                 "y":210
                }],
         "opacity":1,
         "type":"objectgroup",
         "visible":true,
         "x":0,
         "y":0
        }, 
        {
         "draworder":"topdown",
         "id":5,
         "name":"data:units",
         "objects":[
                {
                 "ellipse":true,
                 "height":70,
                 "id":10,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"none"
                        }, 
                        {
                         "name":"key",
                         "type":"string",
                         "value":"axeknight"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":70,
                 "x":700,
                 "y":280
                }, 
                {
                 "ellipse":true,
                 "height":70,
                 "id":12,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":70,
                 "x":910,
                 "y":420
                }, 
                {
                 "ellipse":true,
                 "height":70,
                 "id":14,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"basic"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":70,
                 "x":630,
                 "y":420
                }, 
                {
                 "ellipse":true,
                 "height":70,
                 "id":15,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"basic"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":70,
                 "x":770,
                 "y":770
                }, 
                {
                 "ellipse":true,
                 "height":70,
                 "id":16,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"basic"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":70,
                 "x":490,
                 "y":560
                }, 
                {
                 "ellipse":true,
                 "height":70,
                 "id":17,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"basic"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":70,
                 "x":840,
                 "y":700
                }, 
                {
                 "ellipse":true,
                 "height":70,
                 "id":18,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":70,
                 "x":700,
                 "y":630
                }, 
                {
                 "ellipse":true,
                 "height":70,
                 "id":19,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":70,
                 "x":490,
                 "y":630
                }, 
                {
                 "ellipse":true,
                 "height":70,
                 "id":20,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":70,
                 "x":700,
                 "y":700
                }, 
                {
                 "ellipse":true,
                 "height":70,
                 "id":21,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":70,
                 "x":630,
                 "y":630
                }, 
                {
                 "ellipse":true,
                 "height":70,
                 "id":22,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":70,
                 "x":630,
                 "y":700
                }, 
                {
                 "ellipse":true,
                 "height":70,
                 "id":23,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":70,
                 "x":420,
                 "y":630
                }, 
                {
                 "ellipse":true,
                 "height":70,
                 "id":24,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":70,
                 "x":490,
                 "y":700
                }, 
                {
                 "ellipse":true,
                 "height":70,
                 "id":25,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":70,
                 "x":420,
                 "y":700
                }, 
                {
                 "ellipse":true,
                 "height":70,
                 "id":26,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"basic"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":70,
                 "x":840,
                 "y":770
                }, 
                {
                 "ellipse":true,
                 "height":70,
                 "id":27,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"devil"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"devil"
                        }, 
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"spear"
                        }, 
                        {
                         "name":"key",
                         "type":"string",
                         "value":"archdevil"
                        }, 
                        {
                         "name":"maxhealth",
                         "type":"int",
                         "value":30
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"basic"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":70,
                 "x":420,
                 "y":560
                }, 
                {
                 "ellipse":true,
                 "height":70,
                 "id":28,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"basic"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":70,
                 "x":350,
                 "y":560
                }, 
                {
                 "ellipse":true,
                 "height":70,
                 "id":29,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        }, 
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"sword"
                        }, 
                        {
                         "name":"randomJobKey",
                         "type":"string",
                         "value":"basic"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":70,
                 "x":700,
                 "y":490
                }, 
                {
                 "ellipse":true,
                 "height":70,
                 "id":41,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":70,
                 "x":840,
                 "y":420
                },
            
                {
                 "ellipse":true,
                 "height":70,
                 "id":42,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":70,
                 "x":840,
                 "y":350
                }],
         "opacity":1,
         "type":"objectgroup",
         "visible":true,
         "x":0,
         "y":0
        }],
 "nextlayerid":8,
 "nextobjectid":44,
 "orientation":"orthogonal",
 "renderorder":"right-down",
 "tiledversion":"1.8.6",
 "tileheight":70,
 "tilesets":[],
 "tilewidth":70,
 "type":"map",
 "version":"1.8",
 "width":19
}